import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-close-bold",
  "use": "ico-close-bold-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-close-bold\">\n    <path d=\"M2.13293 13.7626L3.54718 15.1768L14.8609 3.86311L13.4466 2.44886L2.13293 13.7626Z\" />\n    <path d=\"M2.13855 3.86853L13.4523 15.1823L14.8669 13.7677L3.55313 2.45395L2.13855 3.86853Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol